/** Demo Entry Analysis rollout via `REACT_APP_DEMO_ENTRY_ANALYSIS`. */
export function isDemoEntryAnalysisEnabled(): boolean {
  const raw = (process.env.REACT_APP_DEMO_ENTRY_ANALYSIS ?? "false").trim().toLowerCase();
  return raw === "true" || raw === "1" || raw === "yes";
}
